import React from 'react';
import styled from 'styled-components/macro';
import { theme } from 'theme';

type Heading = 'h1' | 'h2' | 'h3' | 'h4';

interface IProps {
  as: Heading;
  size?: Heading;
}

const fontSettings = (size: IProps['size']): { fs: string; mb: string } => {
  switch (size) {
    case 'h1':
      return { fs: theme.typography[3], mb: theme.spacing[2] };
    case 'h2':
      return { fs: theme.typography[2], mb: theme.spacing[2] };
    case 'h3':
      return { fs: theme.typography[1], mb: theme.spacing[2] };
    case 'h4':
      return { fs: theme.typography[-1], mb: theme.spacing[1] };
    default:
      throw new Error(`You have passed in ${size} which is not a valid size.`);
  }
};

const StyledHeading = styled.h1<IProps>`
  font-weight: bold;
  font-size: ${({ size }) => `${fontSettings(size).fs}`};
  margin-bottom: ${({ size }) => `${fontSettings(size).mb}`};
`;

const Heading: React.FC<IProps> = ({ size, as, children }) => {
  return <StyledHeading size={size || as} as={as}>{children}</StyledHeading>;
};

export { Heading };